export var SET_COMMENT_COUNT = 'SET_COMMENT_COUNT';
export var SHOW_COMMENTS = 'SHOW_COMMENTS';
export var HIDE_COMMENTS = 'HIDE_COMMENTS';
export var HIGHLIGHT_COMMENT = 'HIGHLIGHT_COMMENT';
export var UNHIGHLIGHT_COMMENT = 'UNHIGHLIGHT_COMMENT';
export var SHOW_COMMENT_NOTIFICATION = 'SHOW_COMMENT_NOTIFICATION';
export var HIDE_COMMENT_NOTIFICATION = 'HIDE_COMMENT_NOTIFICATION';
export var GET_LEAVE_COMMENT_POPOVER_COOKIE = 'GET_LEAVE_COMMENT_POPOVER_COOKIE';
export var SET_LEAVE_COMMENT_POPOVER_COOKIE = 'SET_LEAVE_COMMENT_POPOVER_COOKIE';
export var RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE = 'RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE';
